import { atomWithStorage } from 'jotai/utils';

export type SignInStep =
  | 'credentials'
  | 'email-verification'
  | 'mfa-enroll'
  | 'mfa-challenge'
  | 'org-selection';

export type OrganizationRecord = {
  id: string;
  name: string;
};

export type SignInState = {
  step: SignInStep;
  email?: string;
  pendingAuthenticationToken?: string;
  authenticated: boolean;

  selectedOrganizationId?: string;
  mfa?: {
    challengeId?: string;
    qrCode?: string;
    recoveryCode?: string;
  };
  organizations?: OrganizationRecord[];
};

// We use atomWithStorage to persist the sign-in state across page reloads
// This is particularly useful for multi-step authentication flows
export const $signIn = atomWithStorage<SignInState>(
  'auth:signInFlow',
  {
    step: 'credentials',
    authenticated: false,
  },
  undefined,
  { getOnInit: true },
);
